import { render, staticRenderFns } from "./PageBackgroundImage.vue?vue&type=template&id=9471f9e6&scoped=true&"
import script from "./PageBackgroundImage.vue?vue&type=script&lang=js&"
export * from "./PageBackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./PageBackgroundImage.vue?vue&type=style&index=0&id=9471f9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9471f9e6",
  null
  
)

export default component.exports